import { useEffect, useState } from "react";
import { CustomComponentProps } from "utils/types/generalTypes";

export type TextAreaProps = CustomComponentProps & {
    handleChangeText: (val: string) => void;
    text: string;
};

const TextArea = ({
    handleChangeText,
    text,
    className,
    style
}: TextAreaProps) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setProgress(() => Math.round((text.length / 250) * 100));
    }, [text]);

    return (
        <div
            className={`post-text-area p-relative pt-20 ${className}`}
            style={style}
        >
            <textarea
                placeholder="Write somthing..."
                onChange={(e) => handleChangeText(e.target.value)}
                value={text}
            ></textarea>

            <div className="progress-holder p-relative">
                <div
                    className="progress-bar p-absolute"
                    style={{ width: `${progress}%` }}
                ></div>
            </div>

            <div className="float-char-length p-absolute momeento-p">
                {text.length}/250
            </div>
        </div>
    );
};

export default TextArea;
